<template>
  <div class="uw-labels">
    <h3 class="mb-8 mt-16 mx-5">
      {{ $ucfirst($t('labels.title', { catalog: 'content' })) }}
    </h3>
    <div class="uw-label__container">
      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/logo.jpg" alt="logo">
        </div>
        <div class="uw-label__description">
          <p>{{ appName }}</p>
          <p class="mt-2"><b>{{ $ucfirst($t('labels.version', { catalog: 'content', params: { versionNumber: appVersionNumber } })) }}</b></p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/md.jpg" alt="md">
        </div>
        <div class="uw-label__description">
          <p>{{ $ucfirst($t('labels.medicalDevice', { catalog: 'content' })) }}</p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/manu.jpg" alt="Manufacturer">
        </div>
        <div class="uw-label__description">
          <p class="mb-2"><b>{{ $ucfirst($t('labels.manufacturer', { catalog: 'content' })) }}</b></p>
          <p v-html="$ucfirst($t('labels.manufacturerDetails', { catalog: 'content' }))" />
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/warning.jpg" alt="Warning">
        </div>
        <div class="uw-label__description">
          <p>{{ $ucfirst($t('labels.warning', { catalog: 'content' })) }}</p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/globe.jpg" alt="Globe">
        </div>
        <div class="uw-label__description">
          <p>{{ $ucfirst($t('labels.browserSupport', { catalog: 'content' })) }}</p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/computer.jpg" alt="Computer">
        </div>
        <div class="uw-label__description">
          <p>
            {{ $ucfirst($t('labels.moreInfo', { catalog: 'content' })) }}
            <a href="http://www.coroprevention.eu/" target="_blank">coroprevention.eu</a>
          </p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/info.jpg" alt="Info">
        </div>
        <div class="uw-label__description">
          <p>
            {{ $ucfirst($t('labels.instructions', { catalog: 'content' })) }}
            <a :href="instructionsUrl" target="_blank">{{ instructionsUrl }}</a>
          </p>
        </div>
      </div>

      <div class="uw-label">
        <div class="uw-label__img">
          <img src="image/labels/manu-line.jpg" alt="Manufacturer line">
        </div>
        <div class="uw-label__description">
          <p>{{ releaseDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import version from '../../version';

export default {
  name: 'SoftwareLabels',
  props: ['appName', 'instructionsUrl'],
  data() {
    return {
      releaseDate: '2022.11.28',
    }
  },
  computed: {
    appVersionNumber() {
      return version;
    }
  }
}
</script>

<style lang="scss" scoped>

  .uw-labels .uw-label__container .uw-label {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 20px;
    border: 1px solid #D6DEEC;
    margin-bottom: 16px;
    overflow: hidden;
  }

  .uw-label__container .uw-label .uw-label__img {
    display: flex;
    height: 100%;
    padding: 24px;
  }

  .uw-label__container .uw-label .uw-label__description {
    min-height: 130px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 19px;
    line-height: 128%;
    padding: 24px;
    font-weight: 400;
    color: #242B44;
    margin: 0;
    border-left: 1px solid #D6DEEC;
  }

  .uw-label__container .uw-label a {
    font-weight: 500;
    color: #421460;
  }

  .uw-label__container .uw-label p {
    margin: 0;
  }

  .uw-label__container .uw-label b {
    font-weight: 500;
  }

  @media only screen and (max-width: 767px) {
    .uw-labels .uw-label__container .uw-label {
      border-radius: 18px;
    }

    .uw-labels .uw-labels__title {
      font-size: 28px;
      margin: 40px auto;
    }

    .uw-label__container .uw-label .uw-label__description {
      font-size: 17px;
    }
  }

  @media only screen and (max-width: 500px) {
    .uw-labels .uw-label__container .uw-label {
      flex-direction: column;
      border-radius: 16px;
    }

    .uw-label__container .uw-label .uw-label__img {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .uw-labels .uw-labels__title {
      font-size: 24px;
    }

    .uw-label__container .uw-label .uw-label__description {
      position: relative;
      font-size: 16px;
      border-left: 0;
      width: 100%;
      border-top: 1px solid #D6DEEC;
    }
  }

  @media only screen and (max-width: 400px) {
    .uw-labels .uw-labels__title {
      font-size: 22px;
    }
  }

</style>